
import { useFetchATSs, useUpdatePreventa } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { ATS, FormEditPreventa } from '@/shared/interfaces';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import { PermissionsEnum } from '@/auth/interfaces';
import { gridSizeMdLg6, ModulosEnumChoice, newPreventaEditVendedorSchema, ROUTER_PATHS, TABLE_CONSTANTS, texto } from '@/shared';
import { useNavigate } from 'react-router-dom';
// import PostAddIcon from '@mui/icons-material/PostAdd';
import { Edit } from '@mui/icons-material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { CustomTextFieldNumberComponente, TabTextLabel } from '@/shared/components/ui';
import { TiposTextFieldNumberEnum } from '@/shared/components/ui/CustomTextFieldNumberComponente';
// import { useAuthStore } from '@/store/auth';
import ModalMotivoRechazo from '@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo';
import { useModalMotivoRechazo } from '@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo';
import { useColumnsATS } from './useColumnsATS';

interface TableATSComponentProps {
  completado: boolean
  enable_action?: boolean
  solicitudesFormatoFisico?: boolean
  apruebaFormatoFisico?: boolean
}
export default function TableATSComponent({
  completado = false,
  enable_action = true,
  solicitudesFormatoFisico = undefined,
  apruebaFormatoFisico = undefined,
}: TableATSComponentProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_analisistrabajoseguro,
    PermissionsEnum.api_change_analisistrabajoseguro
  ]);
  // const userRol = useAuthStore(s => s.user)?.rol;

  const navigate = useNavigate();

  const form = useForm<FormEditPreventa>({
    resolver: yupResolver(newPreventaEditVendedorSchema)
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  ///* State
  const [modal, setModal] = useState(false);

  ///* Fetch
  const { mutateAsync: updatePreventa } = useUpdatePreventa()

  ///* Hook
  const { columnsATS } = useColumnsATS()
  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA
  })

  const {
    pagination,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: atsRes,
    isRefetching, } = useFetchATSs(
      {
        enabled:true,
        params:{
          completado: completado,
          solicita_formato_fisico:solicitudesFormatoFisico,
          aprueba_formato_fisico:apruebaFormatoFisico,
          identificacion: searchTerm,
          page: pageIndex + 1,
          page_size: pageSize,
          ...filterObject,
          filterByState: false
        }
      }
    );





  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<ATS>
            columns={columnsATS}
            data={atsRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={atsRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={enable_action}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
            showCustomActionBtnSpace={enable_action}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                      <Grid item>
                        <Tooltip placement='top' title={'Editar'}>
                          <IconButton
                            onClick={() => {

                              // if (userRol == RolChoiceEnum.SUPERVISOR)
                              //   return navigate(`${ROUTER_PATHS.ventas.preventasEditNav}${value.id_preventa}/${value.prospecto_data.id_prospecto}`);

                              navigate(`${ROUTER_PATHS.tecnico.atsNav}${value.id_analisis_trabajo_seguro}/`);
                              // setModal(true);

                            }}
                          >
                            <Edit color="action" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>


      {/*Modal para cancelar*/}

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

      {/* Modal para editar informacion en modo vendedor */}
      {
        modal && (
          <ScrollableDialogProps
            open={modal}
            title="Editar Información de Preventa"
            confirmTextBtn="Actualizar"
            confirmVariantBtn='contained'
            contentNode={
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <TabTextLabel text={texto.informacion_personal} mt={0} pb={2} pl={0} pt={2} />
                </Grid>

                <CustomTextFieldNumberComponente
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.telefono_fijo}
                  error={errors.celular_2}
                  helperText={errors.celular_2?.message}
                  control={control}
                  name="celular_2"
                  defaultValue={form.getValues().celular_2 || ''}
                />

                <Grid item xs={12}>
                  <TabTextLabel text={texto.informacion_referencia} mt={0} pb={2} pl={0} pt={2} />
                </Grid>

                <CustomTextFieldNumberComponente
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.celular_referencia}
                  error={errors.persona_referencia_celular}
                  helperText={errors.persona_referencia_celular?.message}
                  control={form.control}
                  defaultValue={form.getValues().persona_referencia_celular || ''}
                  name="persona_referencia_celular"
                />

                <CustomTextFieldNumberComponente
                  required={false}
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  label={texto.telefono_fijo_referencia} //TELEFONO ADICIONAL REFERENCIA
                  error={errors.persona_referencia_celular_2}
                  helperText={errors.persona_referencia_celular_2?.message}
                  control={form.control}
                  defaultValue={form.getValues().persona_referencia_celular_2}
                  name="persona_referencia_celular_2"
                />
              </Grid>
            }
            onConfirm={form.handleSubmit(async (formEdit) => {
              await updatePreventa({
                id: form.getValues().id_preventa,
                data: {
                  ...formEdit
                }
              })
              reset({});

              setModal(false)
            })}
            onClose={() => setModal(false)}
          />
        )
      }
    </>
  );


}

